import styled from 'styled-components';

const Thumb = styled.img`
  display: block;
  width: 100%;
  height: auto;
`;

export default Thumb;
